<template>
  <div>
    <h4>Your Active Searches</h4>
    <table v-for="search in searches" :key="search.id">
      <tr>
        <th>Category</th>
        <th>Sub-Category</th>
        <th>Monthly Fee</th>
        <th>Matching Searches</th>
        <th></th>
      </tr>
      <tr>
        <td>{{ search.category }}</td>
        <td>{{ search.SubCategory }}</td>
        <td>Free</td>
        <td>10 items</td>
        <td><a href="#">Remove</a> <a href="#">Edit</a></td>
      </tr>
    </table>
    <p style="margin-top:1em;text-align:left;">Alerts are being sent to {{user.email}}.</p>
    <div style="text-align:right;margin-top:2em;">
      <button @click="add_new_search">Add New Search</button>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    user: function () { return JSON.parse(localStorage.getItem('user')) }
  },
  data () {
    return {
      searches: []
    }
  },
  created () {
    this.getSearches()
  },
  methods: {
    getSearches () {
      this.$store.dispatch('getSearches')
        .then(() => { this.searches = this.$store.getters.userSearches })
        .catch(err => console.log(err))
    },
    add_new_search: function () {
      this.$router.push('/new_search')
    }
  }
}
</script>
<style lang="scss">
  @import '../assets/styles/search_list.scss'
</style>
